export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.id = payload.id;
    state.username = payload.username;
    state.name = payload.name || null;
    state.role = payload.role;
    state.vendor = payload.vendor;
    state.payInStatus = payload.payInStatus;
    state.payOutStatus = payload.payOutStatus;
    state.canApprovePayinManually = !!payload.canApprovePayinManually;
    state.canManageClients = !!payload.canManageClients;
    state.canPickupPartialPayout = !!payload.canPickupPartialPayout;
    // Default ON when the claim is absent (older token/session).
    state.canPartialApprovePayout = payload.canPartialApprovePayout !== false;
    state.isSupporting = !!payload.isSupporting;
    state.exp = payload.exp;
    state.iat = payload.iat;
    state.didAutoLogout = false;
  },
  setPermissions(state, perms) {
    state.permissions = Array.isArray(perms) ? perms : [];
  },
  setJustLoggedIn(state, v) {
    state.justLoggedIn = !!v;
  },
  setAccessNotice(state, msg) {
    state.accessNotice = msg || null;
  },
  setAutoLogout(state) {
    state.token = null;
    state.didAutoLogout = true;
  },
};
